<template>
  <div class="action">
    <template v-if="getUserType === 'observer'">
      <router-link
        v-for="(route, index) in observerRoutes"
        :key="index"
        :to="routeUrl(route)"
        v-bind:class="{ selected: routeSelected(route) }"
        v-show="route.path !== 'record' || hasRecords"
      >
        <el-badge :value="count[route.id]" :hidden="count[route.id] == 0">
          <span
            v-if="route.path === 'record' && hasFlaggedProblems"
            class="flag-icon"
          >
            <img :src="require(`./image/flag-border.svg`)" />
          </span>
          <img class="header-icon" :src="iconType(route.icon, route)" />
        </el-badge>
        <span :title="route.text">{{ route.text }}</span>
        <div class="shadow"></div>
      </router-link>
    </template>
    <template v-else>
      <router-link
        v-for="(route, index) in routes"
        :key="index"
        :to="routeUrl(route)"
        v-bind:class="{ selected: routeSelected(route) }"
        v-show="route.path !== 'record' || hasRecords"
      >
        <el-badge :value="count[route.id]" :hidden="count[route.id] == 0">
          <span
            v-if="route.path === 'record' && hasFlaggedProblems"
            class="flag-icon"
          >
            <img :src="require(`./image/flag-border.svg`)" />
          </span>
          <img class="header-icon" :src="iconType(route.icon, route)" />
        </el-badge>
        <span :title="route.text">{{ route.text }}</span>
        <div class="shadow"></div>
      </router-link>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import isEmptyObj from '@/module/util/empty-object'


export default {
  name: "header-action",

  props: {
    routes: {
      type: Array,
      required: true,
    },
    url: {
      type: String,
      default: "/",
    },
    count: {
      type: Object,
      default: () => ({}),
    },
    hasRecords: {
      type: Boolean,
      default: false,
    },
    hasFlaggedProblems: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      observerHeaderActions: [
        "patient-overview",
        "patient-response",
        "patient-record",
      ],
    };
  },

  computed: {
    ...mapState(["routeName"]),
    observerRoutes() {
      return this.routes.filter((r) =>
        this.observerHeaderActions.includes(r.component.name)
      );
    },
    ...mapGetters(["getUserType"]),
  },

  methods: {
    routeUrl(route) {
      return (
        this.url +
        (this.url.charAt(this.url.length - 1) == "/" ? "" : "/") +
        route.path
        + (this.$route.fullPath.includes('?') ? ( '?' + this.$route.fullPath.split('?')[1]) : '')
      )
    },
    routeSelected(route) {
      var url = this.routeUrl(route);
      if (url.endsWith("/")) url = url.substring(0, url.length - 1);
      return this.routeName === url;
    },
    iconType(icon, route) {
      return this.routeSelected(route)
        ? require(`./image/${icon}-active.png`)
        : require(`./image/${icon}-inactive.png`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./style/action.scss";
.flag-icon {
  position: absolute;
  top: 6px;
  left: 5px;
}
</style>
